import styled from 'styled-components'
import query from 'syf-component-library/const/mediaQueries'
import { spacing } from 'syf-component-library/defaultTheme'
import { Body } from 'syf-component-library/ui/typography'

export const ContentWrapper = styled.div`
  flex-grow: 1;
  padding: ${spacing.xxlarge}px 132px;
  @media ${query.lessThanMedium} {
    padding: ${spacing.xxlarge}px ${spacing.base}px;
  }
`

export const ImageWrapper = styled.div`
  height: 112px;
  width: 168px;
  margin: 0 auto;
  padding: 0 ${spacing.base}px;
  @media ${query.lessThanMedium} {
    height: 96px;
    width: 144px;
    padding: 0 14px;
  }
`

export const BodyContent = styled(Body)`
  text-align: center;
`

export const FooterWrapper = styled.div`
  display: flex;
  align-items: center;

  padding: 16px;
  background: #f6f6f6;
  justify-content: center;
  border-top: 1px solid #e0e0e0;
  box-sizing: border-box;
  flex-direction: column-reverse;

  @media (min-width: 768px) {
    height: 96px;
    min-height: 96px;
    padding: 0 24px;
    flex-direction: row;
    justify-content: flex-end;
  }

  & > button {
    margin: 0;
    min-width: 100%;
    margin-bottom: 8px;

    @media (min-width: 768px) {
      min-width: auto;
      min-height: 48px;
      margin-bottom: 0;
      margin-left: 8px;
    }
  }
`
